import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { hasInvalidRecipients } from 'owa-calendar-event-capabilities';
import hasDistributionListInAttendees from '../utils/hasDistributionListInAttendees';
import {
    setPreviousDate,
    setPreviousDurationInMinutes,
    setTimeSuggestionsRequestState,
    setLastFindMeetingTimesRequestId,
    setLastFindMeetingTimesRequestDate,
} from '../actions/internalActions';
import {
    logTimeSuggestionNotFoundCount,
    clearTimeSuggestionStartLastSet,
} from 'owa-calendar-compose-form-actions';
import { TimeSuggestionsRequestState } from '../store/schema/TimeSuggestionsRequestState';

/**
 * Function to determine whether to show the "no time suggestions found" message
 */
export function shouldShowNoSuggestionsFound(event: CalendarEvent) {
    return (
        event.IsAllDayEvent ||
        event.Recurrence ||
        hasInvalidRecipients(event.RequiredAttendees) ||
        hasInvalidRecipients(event.OptionalAttendees) ||
        hasDistributionListInAttendees([...event.RequiredAttendees, ...event.OptionalAttendees])
    );
}

/**
 * Function which shows the "no time suggestions found" message and clears time suggestions data
 */
export function showNoSuggestionsFound() {
    setTimeSuggestionsRequestState(TimeSuggestionsRequestState.NoSuggestionsFound);
    logTimeSuggestionNotFoundCount();
    resetTimeSuggestionData();
}

/**
 * Function which clears the timeSuggestionStart and reset the previous date and previous duration
 */
export function resetTimeSuggestionData() {
    clearTimeSuggestionStartLastSet();
    setPreviousDate(null);
    setPreviousDurationInMinutes(0);
    setLastFindMeetingTimesRequestId(null);
    setLastFindMeetingTimesRequestDate(null);
}
